import KeyboardIcon from '@mui/icons-material/Keyboard';
import { Box, Button, Container, Divider } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import { useOrientation } from "@uidotdev/usehooks";
import { useEffect, useRef, useState } from "react";
import { BrowserView, MobileView } from "react-device-detect";
import Logo from "../assets/logo_labware.png";
import ResizedLogo from "../assets/logo_labware_resized.png";
import KeyboardImage from "../assets/tastiera.jpg";
import "../KeyboardComponent.css";
import MatricolaPinModal from "./InputModal";
import { MessageType } from './MessageInterface';
import { useWebSocket } from "./WebsocketComponent";
<meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>

const KeyboardMapping: React.FC = () => {

    const buttons = [
        { key: "keyButton", cashValue: 0x7B, width: 1, },
        { key: "function", cashValue: 0x77, width: 1 },
        { key: "tape", cashValue: 0xFD, width: 1 },
        { key: "x", cashValue: 0x0D, width: 1 },
        { key: "rep5", cashValue: 0x03, width: 1 },
        { key: "rep6", cashValue: 0x0B, width: 1 },
        { key: "sconto", cashValue: 0x1B, width: 1 },
        { key: "maggiorazione", cashValue: 0x4D, width: 1 },
        { key: "stornoBox", cashValue: 0x01, width: 1 },
        { key: "number7", cashValue: 0x6C, width: 1 },
        { key: "number8", cashValue: 0x75, width: 1 },
        { key: "number9", cashValue: 0x7D, width: 1 },
        { key: "rep4", cashValue: 0x0C, width: 2, isDouble: true },
        { key: "assegni", cashValue: 0x24, width: 1 },
        { key: "lotteria", cashValue: 0x3C, width: 1 },
        { key: "annulloScontrino", cashValue: 0x78, width: 1 },
        { key: "number4", cashValue: 0x6B, width: 1 },
        { key: "number5", cashValue: 0x73, width: 1 },
        { key: "number6", cashValue: 0x74, width: 1 },
        { key: "rep3", cashValue: 0x04, width: 2, isDouble: true },
        { key: "credito", cashValue: 0xEC, width: 1 },
        { key: "bancomat", cashValue: 0xE9, width: 1 },
        { key: "resoMerce", cashValue: 0x31, width: 1 },
        { key: "number1", cashValue: 0x69, width: 1 },
        { key: "number2", cashValue: 0x72, width: 1 },
        { key: "number3", cashValue: 0x7A, width: 1 },
        { key: "rep2", cashValue: 0x06, width: 2, isDouble: true },
        { key: "subTotal", cashValue: 0x79, width: 2, isDouble: true },
        { key: "clear", cashValue: 0xF1, width: 1 },
        { key: "number0", cashValue: 0x70, width: 1 },
        { key: "number00", cashValue: 0x90, width: 1 },
        { key: "comma", cashValue: 0x71, width: 1 },
        { key: "rep1", cashValue: 0x05, width: 2, isDouble: true },
        { key: "contanti", cashValue: 0xDA, width: 2, isDouble: true }

    ];

    const SMALL_FONT_SIZE = 13
    const MEDIUM_FONT_SIZE = 15
    const LARGE_FONT_SIZE = 18

    const baseStyle = {
        whiteSpace: 'pre-wrap',
        margin: 0,
        lineHeight: 1.2,
    };


    const [containerClass, setContainerClass] = useState('outerBox');
    const [containerClassForIos, setContainerClassForIos] = useState("outerBoxForIos")
    const [isIOS, setIsIOS] = useState(/iPhone|iPad|iPod/i.test(navigator.userAgent))
    const [currentCashValue, setCurrentCashValue] = useState("");
    const [message, setMessage] = useState<MessageType[]>([]);
    const [line1Message, setLine1Message] = useState("");
    const [line2Message, setLine2Message] = useState("");
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [directionButtonPosition, setDirectionButtonPosition] = useState('right');
    const [showLoader, setShowLoader] = useState(false);
    const socket = useWebSocket();
    const [matricola, setMatricola] = useState("");
    const matricolaRef = useRef("");
    const [pin, setPin] = useState("");
    const orientation = useOrientation();


    useEffect(() => {
        matricolaRef.current = matricola;
    }, [matricola])


    useEffect(() => {
        if (!isIOS) {
            if (isFullScreen) {
                //esci
                document.exitFullscreen()
            } else {
                document.documentElement.requestFullscreen().catch(err => {
                    console.log("errore", err)
                })
            }
        }
    }, [orientation.type])

    useEffect(() => {

        function handleWebSocketOpen() {
            if (pin !== null && matricola !== "") {
                window.scrollTo(0, 0)
                document.body.scrollTop = 0;
                socket?.send(JSON.stringify({
                    header: {
                        source: "frontend",
                        version: "1.0",
                        uid: matricola,
                        event: "open",
                        timestamp: Date.now()
                    },
                    body: {
                        pin: pin
                    }
                }));
            }
        }

        handleWebSocketOpen();
    }, [pin, matricola]);


    useEffect(() => {
        function onFullscreenChange() {
            setIsFullScreen(Boolean(document.fullscreenElement));
        }

        document.addEventListener('fullscreenchange', onFullscreenChange);

        return () => document.removeEventListener('fullscreenchange', onFullscreenChange);
    }, []);

    //sending keys to cashsystem.

    const keyButtonFunction = (cashValue: number, key: string) => {
        setCurrentCashValue(key);
        if (socket && socket.readyState !== 3) {
            socket.send(JSON.stringify({
                header: {
                    source: "frontend",
                    version: "1.0",
                    uid: matricola,
                    event: "key",
                    timestamp: Date.now()
                },
                body: {
                    key: cashValue
                }
            }));

        } else {
            console.log("il messaggio non e' stato inviato.");
        }
    }


    const getStyle = (style: number, text: string): React.ReactNode => {
        if (text.trim() === 'div') {
            return <Divider style={{ width: '100%', borderWidth: '1px', marginTop: "1rem", marginBottom: "1rem" }} />;
        }

        switch (style) {
            case 0:
                return <p style={{ margin: 0, lineHeight: 1.2, whiteSpace: 'pre-wrap', fontSize: SMALL_FONT_SIZE }}>{text}</p>;
            case 1:
                return <p style={{ margin: 0, lineHeight: 1.2, whiteSpace: 'pre-wrap', fontSize: MEDIUM_FONT_SIZE }}>{text}</p>;
            case 2:
                return <p style={{ margin: 0, lineHeight: 1.2, whiteSpace: 'pre-wrap', fontSize: LARGE_FONT_SIZE }}>{text}</p>;
            default:
                return <p style={{ margin: 0, lineHeight: 1.2, whiteSpace: 'pre-wrap', fontSize: SMALL_FONT_SIZE }}>{text}</p>;
        }
    };

    const renderReceipt = () => {
        if (!message?.length) return null;

        return message.map((msg, msgIndex) =>
            msg.body.lines.map((line, lineIndex) => (
                <Box style={{ padding: 0 }}
                    className="receipt-content"
                    key={`${msgIndex}-${lineIndex}`}
                >
                    {getStyle(line.style, line.text)}
                </Box>
            ))
        );
    };

    function handleSocketMessage(event: MessageEvent) {
        const parsedData = JSON.parse(event.data);

        switch (parsedData.header.event) {
            case "print":
                setMessage(prev => [...prev, parsedData as MessageType]);
                break;

            case "screen":

                setLine1Message(parsedData.body.line1 ?? "");
                setLine2Message(parsedData.body.line2 ?? "");
                setShowLoader(false);
                // clearTimeout(timeoutId);
                break;

            default:
                console.log("Evento sconosciuto:", parsedData.header.event);
        }
    }

    //time function that checks if the cashsystem is still connected to the websocket channel
    /*
    after 5 seconds a loader gets rendered into page, after another 15 seconds a message gets sent
    to the server which triggers an error to the frontend connected to the disconnected cashsystem
    */
    // function startTimer() {
    //     if (matricolaRef.current) {
    //         timeoutId = setTimeout(() => {
    //             setShowLoader(true);
    //             loaderTimeoutId = setTimeout(() => {
    //                 if (socket && socket.readyState !== WebSocket.CLOSED) {
    //                     socket.send(JSON.stringify({
    //                         header: {
    //                             source: "frontend",
    //                             version: "1.0",
    //                             uid: matricolaRef.current,
    //                             event: "cashsystemTimeout",
    //                             timestamp: Date.now()
    //                         },
    //                         body: {

    //                         }
    //                     }));
    //                 }
    //                 setShowLoader(false)
    //             }, 15000);
    //         }, 5000);
    //     }
    // }

    // function resetTimer() {
    //     clearTimeout(timeoutId);
    //     clearTimeout(loaderTimeoutId);
    //     startTimer();
    // }


    useEffect(() => {
        if (socket && socket.readyState !== WebSocket.CLOSED) {
            socket.addEventListener('message', (event: any) => {
                handleSocketMessage(event);
                // resetTimer();
            });
            // startTimer();
        }

        return () => {
            // clearTimeout(timeoutId);
            if (socket && socket.readyState !== WebSocket.CLOSED) {
                socket.removeEventListener('message', handleSocketMessage);
            }
        };
    }, [socket]);

    const handleButtonClickForIos = () => {
        if (containerClassForIos === 'outerBoxForIos') {
            setContainerClassForIos("new-container-classForIos");
            setDirectionButtonPosition('left');
        } else {
            setContainerClassForIos("outerBoxForIos");
            setDirectionButtonPosition('right');
        }
    }

    const handleButtonClick = () => {
        if (containerClass === 'outerBox') {
            setContainerClass('new-container-class');
            setDirectionButtonPosition('left');
        } else {
            setContainerClass('outerBox');
            setDirectionButtonPosition('right');
        }
    };

    return (

        <Container className="container" disableGutters sx={{ margin: "0", display: "flex" }}>

            <BrowserView>
                {showLoader ?
                    <Box className="loader-box">
                        <CircularProgress
                            color="error"
                        />
                    </Box>

                    :

                    null
                }
                <Box sx={{ display: "flex", flexDirection: "column", filter: `${showLoader ? "blur(3px)" : undefined}` }} >
                    <Box className="logoImage">
                        <img src={Logo} draggable="false" loading="lazy" />
                    </Box>
                    <Box className="otherBox">
                        <Box className="Visori">
                            <Box className="displayOne" sx={{ height: "29px" }}>
                                {line1Message !== "" ? line1Message : currentCashValue}
                            </Box>
                            <Box className="displayTwo" sx={{ height: "29px" }}>
                                {line2Message !== "" ? line2Message : currentCashValue}
                            </Box>
                        </Box>
                    </Box>

                    <Box className="imageBox" sx={{
                        backgroundImage: `url(${KeyboardImage})`, backgroundRepeat: "no-repeat", display: "flex",
                        flexDirection: "row", flexWrap: "wrap", alignContent: "flex-start", paddingTop: "11px", paddingLeft: "7px", boxSizing: "border-box",
                        PointerEvent: `${showLoader ? "none" : "auto"}`, cursor: `${showLoader ? "not-allowed" : "pointer"}`
                    }}>
                        {buttons.map(x => {
                            return <Box onClick={() => keyButtonFunction(x.cashValue, x.key)} className={x.key + " divLayout" + (x.width === 2 ? " divRectangle" : "")} />

                        })}
                    </Box>
                    <Box className="receipt" id="style-13">
                        {renderReceipt()}
                    </Box>
                </Box>

                <MatricolaPinModal onSubmit={(matricola: string, pin: string) => {
                    setMatricola(matricola);
                    setPin(pin);
                }}
                    widthMax={"247px"}
                />
            </BrowserView>
            <MobileView>
                <MatricolaPinModal onSubmit={(matricola: string, pin: string) => {
                    setMatricola(matricola);
                    setPin(pin);
                }}
                    widthMax={"205px"}
                />

                {showLoader ?

                    <Box className="loader-box">
                        <CircularProgress
                            color="error"
                        />
                    </Box>

                    :

                    null
                }
                <Box className={isIOS ? containerClassForIos : containerClass} sx={{ filter: `${showLoader ? "blur(3px)" : undefined}` }}>
                    <Box className="logoImage">
                        <img src={ResizedLogo} draggable="false" />
                    </Box>
                    <Box className="otherBox">
                        <Box className="receipt">
                            {isIOS ? "e' ios" : "non e' ios"}
                        </Box>
                        <Box className="Visori">
                            <Box className="displayOne" sx={{ height: "29px" }}>
                                {line1Message !== "" ? line1Message : currentCashValue}
                            </Box>
                            <Box className="displayTwo" sx={{ height: "29px" }}>
                                {line2Message !== "" ? line2Message : currentCashValue}
                            </Box>
                        </Box>
                    </Box>

                    <Box className="imageBox" sx={{
                        backgroundImage: `url(${KeyboardImage})`, backgroundRepeat: "no-repeat", display: "flex",
                        flexDirection: "row", flexWrap: "wrap", alignContent: "flex-start", paddingTop: "11px", paddingLeft: "7px", boxSizing: "border-box",
                        PointerEvent: `${showLoader ? "none" : "auto"}`
                    }}>
                        {buttons.map(x => {
                            return <Box onClick={() => keyButtonFunction(x.cashValue, x.key)} className={x.key + " divLayout" + (x.width === 2 ? " divRectangle" : "")} />

                        })}
                    </Box>
                </Box>
                <Box className="directionButton" sx={{ position: "fixed", [directionButtonPosition]: "0", bottom: "0" }}>
                    <Button
                        className="bottone"
                        onClick={isIOS ? handleButtonClickForIos : handleButtonClick}
                        variant="contained"
                        color="error"
                        size="medium"
                        endIcon={<KeyboardIcon sx={{ margin: "0px" }} />}>
                    </Button>
                </Box>
            </MobileView>
        </Container >
    )

}


export default KeyboardMapping;


